document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu
  const ham = document.getElementById('ham');
  const mob = document.getElementById('mob');
  const mobX = document.getElementById('mob-x');
  if (ham) ham.addEventListener('click', () => mob.classList.add('open'));
  if (mobX) mobX.addEventListener('click', () => mob.classList.remove('open'));

  // Popup — once per session
  const popup = document.getElementById('popup');
  const popX = document.getElementById('pop-x');
  if (popup && !sessionStorage.getItem('at_p')) {
    setTimeout(() => { popup.classList.add('open'); sessionStorage.setItem('at_p','1'); }, 900);
  }
  if (popX) popX.addEventListener('click', () => popup.classList.remove('open'));

  // Countdown
  if (typeof DEADLINE !== 'undefined' && typeof LAUNCH_MODE !== 'undefined' && LAUNCH_MODE) {
    const dl = new Date(DEADLINE).getTime();
    function tick() {
      const diff = dl - Date.now();
      if (diff <= 0) {
        const cd = document.getElementById('cd');
        const ended = document.getElementById('ended');
        const bar = document.getElementById('bar');
        if (cd) cd.style.display = 'none';
        if (ended) ended.style.display = 'block';
        if (bar) bar.innerHTML = 'THE INTRODUCTORY OFFER HAS ENDED. <a href="/pages/collections" style="color:var(--gd);border-bottom:1px solid var(--gd)">View Regular Pricing &rarr;</a>';
        return;
      }
      const p = n => String(Math.floor(n)).padStart(2,'0');
      const s = (id,v) => { const e = document.getElementById(id); if(e) e.textContent = p(v); };
      s('cd-d', diff/86400000);
      s('cd-h', (diff%86400000)/3600000);
      s('cd-m', (diff%3600000)/60000);
      s('cd-s', (diff%60000)/1000);
      setTimeout(tick, 1000);
    }
    tick();
  }

  // Pre-select package from URL param
  const pkg = new URLSearchParams(window.location.search).get('pkg');
  if (pkg) {
    const o = document.querySelector(`.popt input[value="${pkg}"]`);
    if (o) o.closest('.popt').click();
  }
});

function faq(btn) {
  const item = btn.closest('.faq-item'), was = item.classList.contains('on');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('on'));
  if (!was) item.classList.add('on');
}

function spkg(el, v) {
  document.querySelectorAll('.popt').forEach(o => o.classList.remove('sel'));
  el.classList.add('sel');
  el.querySelector('input').checked = true;
  const note = document.getElementById('note-2pack');
  if (note) note.style.display = (v === 'classic-2pack') ? 'block' : 'none';
}

function ufiles(inp) {
  const e = document.getElementById('flist');
  if (e && inp.files.length) {
    e.innerHTML = Array.from(inp.files).map(f =>
      `<div style="padding:.25rem 0;border-bottom:1px solid var(--pr);font-size:.54rem;color:var(--tp)">📎 ${f.name}</div>`
    ).join('');
  }
}

function suborder() {
  const form = document.getElementById('oform');
  const conf = document.getElementById('oconf');
  if (form) form.style.display = 'none';
  if (conf) conf.classList.add('show');
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
